
const incomeTypeEnum = {
 INCOME: 'INCOME',
 LUMPSUM: 'LUMPSUM',
}

export default incomeTypeEnum;

